import { Link } from '@components'
import { type CSSPropertiesWithCustomVars } from '../../utilities/css-vars'
import { useTranslation } from 'react-i18next'
import { useActiveOrder } from '@haus-storefront-react/hooks'
import type { CartQuantityAttributes } from './_propsFn'
import styles from './CartQuantity.module.scss'

export default function CartQuantity({ configStyles }: CartQuantityAttributes) {
  const { data: activeOrder } = useActiveOrder()
  const count = activeOrder?.totalQuantity || 0
  const { t } = useTranslation()

  const ariaLabel =
    count > 0
      ? t('a11y.cartIcon.aria.ariaLabelWithCount', { itemCount: count })
      : t('a11y.cartIcon.aria.ariaLabel')

  const badgeBackgroundColorSlug = configStyles?.badgeBackgroundColor?.color ?? 'primary'
  const badgeTextColorSlug = configStyles?.badgeTextColor?.color ?? 'body'

  const rootStyle: CSSPropertiesWithCustomVars = {
    '--haus-carticon__cartBadge__background-color': `var(--haus-color-${badgeBackgroundColorSlug})`,
    '--haus-carticon__cartBadge__color': `var(--haus-color-${badgeTextColorSlug})`,
  }

  return (
    <div className={styles.root} style={rootStyle}>
      <Link href={t('urls.cart')} className={styles.cartButton} aria-label={ariaLabel}>
        {count > 0 && (
          <div className={styles.cartBadge} aria-hidden="true">
            <span>{count}</span>
          </div>
        )}
      </Link>
    </div>
  )
}
